import { toast } from "sonner";
import { MonitorDown } from "lucide-react";
import { Button } from "@/components/ui/button";

const APP_NAME = "Medical CDSS";

function shortcutFile() {
  const url = window.location.origin + "/";
  const ua = window.navigator.userAgent;
  if (/Macintosh|Mac OS X/i.test(ua)) {
    return {
      name: `${APP_NAME}.webloc`,
      type: "application/x-apple-plist",
      body: `<?xml version="1.0" encoding="UTF-8"?>\n<!DOCTYPE plist PUBLIC "-//Apple//DTD PLIST 1.0//EN" "http://www.apple.com/DTDs/PropertyList-1.0.dtd">\n<plist version="1.0"><dict><key>URL</key><string>${url}</string></dict></plist>\n`,
    };
  }
  if (/Linux/i.test(ua) && !/Android/i.test(ua)) {
    return {
      name: "medical-cdss.desktop",
      type: "application/x-desktop",
      body: `[Desktop Entry]\nType=Link\nName=${APP_NAME}\nURL=${url}\nIcon=web-browser\n`,
    };
  }
  return {
    name: `${APP_NAME}.url`,
    type: "application/octet-stream",
    body: `[InternetShortcut]\r\nURL=${url}\r\nIconFile=${url}favicon.ico\r\nIconIndex=0\r\n`,
  };
}

export default function DesktopShortcutButton() {
  const download = () => {
    const f = shortcutFile();
    const href = URL.createObjectURL(new Blob([f.body], { type: f.type }));
    const a = Object.assign(document.createElement("a"), { href, download: f.name });
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(href);
    toast.success(`Shortcut downloaded — move "${f.name}" from Downloads to your Desktop.`, { duration: 8000 });
  };

  return (
    <Button variant="outline" size="sm" onClick={download} data-testid="desktop-shortcut-btn"
      className="border-zinc-300 hidden md:inline-flex" title="Download a desktop shortcut to Medical CDSS">
      <MonitorDown className="h-4 w-4 lg:mr-2" /> <span className="hidden lg:inline">Desktop shortcut</span>
    </Button>
  );
}
